import * as PIXI from 'pixi.js';

export default class Confetti {
    constructor() {
        this.init();
    }

    init() {
        this.cw = window.innerWidth;
        this.ch = window.innerHeight;
        this.createNum = this.getCreateNum();
        this.color = [0xffffff, 0xff686e, 0x65c3ea];
        this.xAdd = [];
        this.graphics = [];
        this.scale = [];
        this.killed = false;

        this.createPixi();
        this.render();
        this.onScroll();
    }

    onScroll() {
        const scrollFunc = () => {
            const scrollY = window.scrollY;
            if (scrollY >= 200) {
                this.killRender();
                window.removeEventListener('scroll', scrollFunc);
            }
        };
        window.addEventListener('scroll', scrollFunc);
    }

    getCreateNum() {
        let num = 0;

        if (window.innerWidth < 768) {
            num = 25;
        } else {
            num = 40 * (window.innerWidth / 1920);
        }

        return num;
    }

    getRandGraphics(colornum, randType) {
        const rect = new PIXI.Graphics();
        const circle = new PIXI.Graphics();
        const tri = new PIXI.Graphics();
        const tScale = 2;

        rect.paint = () => {
            rect.beginFill(this.color[colornum], 1).drawRect(0, 0, 20, 20);
        };

        circle.paint = () => {
            circle.beginFill(this.color[colornum], 1).drawCircle(0, 0, 10);
        };

        tri.paint = () => {
            tri.beginFill(this.color[colornum], 1)
                .moveTo(0, 0)
                .lineTo(5 * tScale, 0)
                .lineTo(0, 9 * tScale)
                .lineTo(-5 * tScale, 0)
                .endFill();
        };

        const arr = [rect, circle, tri];

        return arr[randType];
    }

    createPixi() {
        this.app = new PIXI.Application({ width: this.cw, height: this.ch, backgroundAlpha: 0, resolution: Math.min(2, window.devicePixelRatio || 1), autoResize: true });
        this.app.view.classList.add('l-canvas');
        document.body.appendChild(this.app.view);

        for (let i = 0; i < this.createNum; i++) {
            const color = i % this.color.length;
            const x = Math.floor(Math.random() * this.cw) + 10;
            const y = Math.floor(Math.random() * this.ch);
            const randType = Math.floor(Math.random() * 3);

            this.scale.push(window.innerWidth < 768 ? Math.random() + 0.2 : Math.random() * 1.5 + 0.2);
            this.xAdd.push(i % 2 === 0 ? 1 : -1);

            this.graphics.push(this.getRandGraphics(color, randType));
            this.graphics[i].position.x = x;
            this.graphics[i].position.y = y;
            this.graphics[i].scale.x = this.scale[i];
            this.graphics[i].scale.y = this.scale[i];
            //this.graphics[i].skew.y = (i % 10) * 0.1;
            this.graphics[i].rotation = 0.1 + (i % 5) * 0.1;
            this.app.stage.addChild(this.graphics[i]);
        }

        window.addEventListener('resize', this.onResize.bind(this));
    }

    onResize() {
        this.cw = window.innerWidth;
        this.ch = window.innerHeight;
        this.app.renderer.resize(this.cw, this.ch);
    }

    render() {
        this.app.ticker.add((delta) => this.update(delta));
    }

    killRender() {
        if (this.killed) {
            return;
        }
        this.killed = true;
        this.app.view.classList.add('-disable');
        setTimeout(() => {
            this.app.ticker.stop();
        }, 1000);
    }

    update(delta) {
        const skew = [0.02, 0.04, 0.06, 0.08, 0.1];
        const xPlus = [0.5, 0.75, 1, 1.2, 1.5];

        for (let i = 0; i < this.createNum; i++) {
            let x;
            let y;

            this.graphics[i].clear();
            this.graphics[i].paint();

            if (this.graphics[i].y > this.ch) {
                x = Math.floor(Math.random() * this.cw) + 10;
                y = -10;
            } else {
                y = this.graphics[i].y + 3 + (i % 5) * 0.1;
            }

            if (this.graphics[i].x > this.cw - 10) {
                this.xAdd[i] = -1;
            } else if (this.graphics[i].x < 10) {
                this.xAdd[i] = 1;
            }

            if (this.xAdd[i] === -1) {
                x = this.graphics[i].x - xPlus[i % 5];
            } else {
                x = this.graphics[i].x + xPlus[i % 5];
            }

            this.graphics[i].position.x = x;
            this.graphics[i].position.y = y;
            //this.graphics[i].skew.y += i % 2 === 0 ? skew[i % 5] : skew[i % 5] * -1;
            this.graphics[i].rotation += i % 2 === 0 ? 0.01 + (i % 5) * 0.01 : 0.01 + (i % 5) * -0.01;
        }
    }
}
